/**
 * Footer Component
 */

export default function Footer() {
  return (
    <footer>
      <p>&copy; 2025 Rocketship Readers</p>
    </footer>
  )
}
